import { saveAs } from "file-saver";

const downloader = {
    download: function($axios, url, params = {}){
        return new Promise((resolve, reject) => {
            this.downloadAsync($axios, url, params)
            .then((r) => resolve(r))
            .catch((e) => reject(e))
            ;
        });
    },
    downloadPost: function($axios, url, params = {}){
        return new Promise((resolve, reject) => {
            this.downloadAsyncPost($axios, url, params)
            .then((r) => resolve(r))
            .catch((e) => reject(e))
            ;
        });
    },
    
    downloadAsync: async function($axios, url, params = {}){
        return $axios.get(url,
                {
                    params: params,
                    responseType: "blob",
                    dataType:'binary'
                }
            )
            .then(response => {
                this.saveFile(response);
                return response.status;
            })
            .catch(error => {
                throw error;
            });
    },

    downloadAsyncPost: async function($axios, url, params = {}){
        return $axios.post(url,
                params,
                {
                    responseType: "blob",
                    dataType:'binary'
                }
            )
            .then(response => {
                this.saveFile(response);
            })
            .catch(error => {
                throw error;
            })
    },
    getFileName: function(contentDisposition){
        let useAsta = /.*filename\*=.*/.test(contentDisposition);
        const filenameRegex = useAsta ? /filename\*[^;=\n]*=utf-8((['"]['"]).*[^;\n]*)/ : /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
            const fileName = matches[1].replace(/['"]/g, '');
            return decodeURI(fileName).replace(/\+/g, " ");
        } else {
            return null
        }
    },
    saveFile: function (response) {
        let blob = new Blob(
                [response.data],
                {type: response.headers["Content-Type"]}
                );
        let fName = this.getFileName(response.headers["content-disposition"])
        saveAs(blob, fName);
    }
}

export default ({ app }, inject) => {
    inject('downloader', downloader);
}